// static#faq — searchable FAQ, rendered by React from the JSON blob the view
// prints into #faq-data.
import { registerPage } from "../first"
import { mountFaqApp } from "../faq"

export const StaticFaqPage = {
  onDomReady(): void {
    mountFaqApp()
  },
}

registerPage("StaticFaqPage", StaticFaqPage)
